var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"equipments-list"},_vm._l((_vm.products),function(product){return (product)?_c('equipment-list-item',{key:product.identifier,attrs:{"product":product,"item-style":_vm.listType}}):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }